import { TRM_CONSTANTS } from '../../pages/constants/trmConstants';
import { AMLS_TM_IAD } from '../../pages/constants/globalConstants';
import { TrmTypologies } from './apiModules/trmDashboardModule/trmTypologies';
import { TrmUpload } from './apiModules/trmUploadModule/trmUpload';
import { TestScenarioDashboard } from './apiModules/trmTestScenarioModule/testScenarioDashboard';
import { TicketsDashboard } from './apiModules/trmTicketsDashboard/ticketsDashboard';
import ConfigurationModule from './apiModules/ConfigurationPageModules/configurationModule';
import RiskIndicatorModule from './apiModules/RiskIndicatorModule';
import ThresholdGenerationModule from './apiModules/ThresholdGenerationModule';
import ScoringConfigModule from './apiModules/ScoringConfigModule';
/**
 * NetworkLayer for TRM
 */
export class NetworkLayer {
  constructor() {
    const { TRM_BASE_URL, HTTP_HEADERS } = TRM_CONSTANTS;

    this.trmDashboardModule = new TrmTypologies(TRM_BASE_URL, HTTP_HEADERS);
    this.trmUploadModule = new TrmUpload(TRM_BASE_URL, HTTP_HEADERS);

    this.trmTestScenarioModule = new TestScenarioDashboard(
      TRM_BASE_URL,
      AMLS_TM_IAD,
      HTTP_HEADERS
    );
    this.trmTicketsModule = new TicketsDashboard(TRM_BASE_URL, HTTP_HEADERS);
    this.configurationModule = new ConfigurationModule(
      TRM_BASE_URL,
      HTTP_HEADERS
    );

    this.riskIndicatorModule = new RiskIndicatorModule(
      TRM_BASE_URL,
      HTTP_HEADERS
    );

    this.thresholdGenerationModule = new ThresholdGenerationModule(
      TRM_BASE_URL,
      HTTP_HEADERS
    );

    this.scoringConfigModule = new ScoringConfigModule(
      TRM_BASE_URL,
      HTTP_HEADERS
    );
  }

  trmTypologiesAPI = async (payload) =>
    await this.trmDashboardModule.getTypologiesAPI(payload);
  trmScenarioTypologiesListAPI = async (payload) =>
    await this.trmDashboardModule.getTypologiesOfScenariosAPI(payload);
  removeTypologyFromScenarioAPI = async (payload) =>
    await this.trmDashboardModule.removeTypologyFromScenario(payload);
  putTypologyFromScenarioAPI = async (payload) =>
    await this.trmDashboardModule.updateTypologiesOfScenariosAPI(payload);

  trmConfirmUploadAPI = async (payload) =>
    await this.trmUploadModule.confirmTRMUpload(payload);
  trmDiscardUploadAPI = async (payload) =>
    await this.trmUploadModule.discardTRMUpload(payload);

  // configure run instance services

  saveTypologySegmentAPI = async (payload) =>
    await this.trmTestScenarioModule.saveTypologySegments(payload);

  fetchScenarioTypologiesAPI = async (payload) =>
    await this.trmTestScenarioModule.getScenarioTypologies(payload);

  // end

  getAllScenariosAPI = async (payload) =>
    await this.trmTestScenarioModule.getAllScenarios(payload);
  getSingleScenarioDetailAPI = async (payload) =>
    await this.trmTestScenarioModule.getSingleScenarioDetails(payload);

  triggerScenariosAPI = async (payload) =>
    await this.trmTestScenarioModule.triggerScenario(payload);
  // FIN-11800: Launch saga gate — see sagas/trm/trmDashboard.js.
  validateScenarioAPI = async (scenarioID) =>
    await this.trmTestScenarioModule.validateScenario(scenarioID);
  deleteScenarioAPI = async (payload) =>
    await this.trmTestScenarioModule.deleteScenario(payload);
  cloneScenarioAPI = async (payload) =>
    await this.trmTestScenarioModule.cloneScenario(payload);
  updateScenarioAPI = async (payload) =>
    await this.trmTestScenarioModule.updateScenario(payload);
  addMappingToScenarioAPI = async (payload) =>
    await this.trmTestScenarioModule.addMappingToScenario(payload);
  createScenarioAPI = async (payload) =>
    await this.trmTestScenarioModule.createScenario(payload);
  getRunInstanceHistoryAPI = async (payload) =>
    await this.trmTestScenarioModule.getRunInstanceHistory(payload);

  fetchTicketsListAPI = async (payload) =>
    await this.trmTicketsModule.fetchTicketsList(payload);
  approveRejectTicketsAPI = async (payload) =>
    await this.trmTicketsModule.approveRejectTickets(payload);
  fetchCurrentChampionAPI = async (payload) =>
    await this.trmTicketsModule.fetchCurrentChampion(payload);
  fetchCurrentChallengerAPI = async (payload) =>
    await this.trmTicketsModule.fetchCurrentChallenger(payload);
  createChallengerAPI = async (payload) =>
    await this.trmTicketsModule.createChallenger(payload);

  fetchChallengersSummariesAPI = async (payload) =>
    await this.trmTicketsModule.fetchChallengerSummaries(payload);
  revertCurrentChampionAPI = async (payload) =>
    await this.trmTicketsModule.revertCurrentChampion(payload);

  promoteChallengerAPI = (payload) =>
    this.trmTicketsModule.promoteChallenger(payload);

  promoteChallengerAPI = (payload) =>
    this.trmTicketsModule.promoteChallenger(payload);

  getConfigurationAPI = async () =>
    await this.configurationModule.fetchTRMConfigurations();
  updateConfigurationAPI = async (payload) =>
    await this.configurationModule.updateTRMConfigurations(payload);

  getRIByScenarioId = async (payload) =>
    await this.riskIndicatorModule.fetchRIByScenarioId(payload);
  putRIByScenarioId = async (payload) =>
    await this.riskIndicatorModule.updateRIByScenarioId(payload);

  triggerThresholdGenerationAPI = async (payload) =>
    await this.thresholdGenerationModule.triggerThresholdGeneration(payload);
  getThresholdStatusAPI = async (payload) =>
    await this.thresholdGenerationModule.getThresholdStatus(payload);
  discardThresholdGenerationAPI = async (payload) =>
    await this.thresholdGenerationModule.discardThresholdGeneration(payload);
  getThresholdResultsAPI = async (payload) =>
    await this.thresholdGenerationModule.getThresholdResults(payload);
  getThresholdConfigAPI = async (payload) =>
    await this.thresholdGenerationModule.getThresholdConfig(payload);

  getScoringConfigAPI = async (payload) =>
    await this.scoringConfigModule.getScoringConfig(payload);
  putScoringConfigAPI = async (payload) =>
    await this.scoringConfigModule.putScoringConfig(payload);
  deleteScoringConfigAPI = async (payload) =>
    await this.scoringConfigModule.deleteScoringConfig(payload);

  // FIN-12215: tenant/global default scoring config
  getDefaultScoringConfigAPI = async (payload) =>
    await this.scoringConfigModule.getDefaultScoringConfig(payload);
  putDefaultScoringConfigAPI = async (payload) =>
    await this.scoringConfigModule.putDefaultScoringConfig(payload);

  // FIN-12421 Item 7: tenant/global FRAML decay policy (framl_decay_policy row).
  // GET returns null when scoring is disabled on the deployment (BE returns 404 and the
  // module normalises to null); the FRAML Settings tab pane renders a "not enabled"
  // state in that case.
  getFramlDecayPolicy = async () =>
    await this.scoringConfigModule.getFramlDecayPolicy();
  putFramlDecayPolicy = async (payload) =>
    await this.scoringConfigModule.putFramlDecayPolicy(payload);
}
